import { applicationApi } from "common/api";
import { AnswerQuestionaireRequest, QuestionaireResponse, StartQuestionaireRequest } from "models/flQuestionaire";

// Define a service using a base URL and expected endpoints
export const questionaireResultApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    get: builder.query<QuestionaireResponse, string>({
      query: (query) => `bdc/questionaire/${query}`,
      providesTags: [{ type: "QuestionaireResult", id: "QuestionaireResult" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetQuery } = questionaireResultApi;
